import React from 'react';

interface Props extends React.ComponentProps<'svg'> {
  /** Props of circle surrounding the X */
  circleProps?: React.ComponentProps<'circle'>;
  /** Props of paths making up the X */
  pathProps?: React.ComponentProps<'path'>;
}

const NotSubmittedIcon = ({ circleProps, pathProps, ...rest }: Props) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="15.5" cy="15.5" r="15.5" fill="#F12D40" {...circleProps} />
      <path d="M10.5 20.5L21 10" stroke="white" strokeWidth="2" {...pathProps} />
      <path d="M10.1677 10.0003L20.4987 20.6666" stroke="white" strokeWidth="2" {...pathProps} />
    </svg>
  );
};

export default NotSubmittedIcon;
